// src/components/NumeroConfigModal.jsx
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "500px",
    padding: "20px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "none",
    fontFamily: "Roboto, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 202,
  },
};

const swalTopZIndex = (z = 222) => ({
  willOpen: () => {
    const container = document.querySelector(".swal2-container");
    if (container) container.style.zIndex = String(z);
  },
});

export default function NumeroConfigModal({
  isOpen,
  onClose,
  title = "Configurar número",
  modoInicial,
  prefijoInicial,
  siguienteInicial,
  onChangeNumeroFormatted,
}) {
  const [modo, setModo] = useState(modoInicial);
  const [prefijo, setPrefijo] = useState(prefijoInicial);
  const [siguiente, setSiguiente] = useState(siguienteInicial);

  useEffect(() => {
    setModo(modoInicial);
    setPrefijo(prefijoInicial);
    setSiguiente(siguienteInicial);
  }, [modoInicial, prefijoInicial, siguienteInicial]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // 1) Guardamos la configuración
    await onChangeNumeroFormatted({ modo, prefijo, siguiente });
    // 2) Avisamos al usuario
    const mensaje =
      modo === "auto"
        ? "Ahora los números se generarán automáticamente."
        : "Ahora los números se generarán manualmente.";
    await Swal.fire({
      icon: "success",
      title: mensaje,
      timer: 1400,
      showConfirmButton: false,
      ...swalTopZIndex(100000),
    });
    // 3) Cerramos el modal
    onClose();
  };

  const handleModoAuto = () => {
    if (modo !== "auto") {
      Swal.fire({
        icon: "info",
        title: "Has cambiado a modo Automático",
        timer: 1200,
        showConfirmButton: false,
        ...swalTopZIndex(100000),
      });
      setModo("auto");
    }
  };

  const handleModoManual = () => {
    if (modo !== "manual") {
      Swal.fire({
        icon: "info",
        title: "Has cambiado a modo Manual",
        timer: 1200,
        showConfirmButton: false,
        ...swalTopZIndex(100000),
      });
      setModo("manual");
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
      <h2
        style={{
          fontSize: 20,
          color: "#333",
          marginBottom: 15,
          textAlign: "center",
        }}
      >
        {title}
      </h2>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: 20 }}
      >
        {/* Modo AUTO */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <input
            id="modo-auto"
            type="radio"
            value="auto"
            checked={modo === "auto"}
            onChange={handleModoAuto}
          />
          <label htmlFor="modo-auto" style={{ cursor: "pointer" }}>
            Continuar generando automáticamente números
          </label>
        </div>

        {modo === "auto" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 20,
            }}
          >
            {/* Prefijo */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontWeight: 500 }}>Prefijo</span>
              <input
                type="text"
                value={prefijo}
                onChange={(e) => setPrefijo(e.target.value)}
                style={{
                  width: 80,
                  padding: "6px 8px",
                  borderRadius: 4,
                  border: "1px solid #ccc",
                  textAlign: "center",
                }}
              />
            </div>

            {/* Siguiente número con 4 dígitos */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontWeight: 500 }}>Siguiente número</span>
              <input
                type="text"
                value={String(siguiente).padStart(4, "0")}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "");
                  setSiguiente(digits === "" ? 0 : Number(digits));
                }}
                style={{
                  width: 80,
                  padding: "6px 8px",
                  borderRadius: 4,
                  border: "1px solid #ccc",
                  textAlign: "center",
                }}
              />
            </div>
          </div>
        )}

        {/* Modo MANUAL */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <input
            id="modo-manual"
            type="radio"
            value="manual"
            checked={modo === "manual"}
            onChange={handleModoManual}
          />
          <label htmlFor="modo-manual" style={{ cursor: "pointer" }}>
            Introducir números manualmente
          </label>
        </div>

        {/* Botones */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 20,
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "#6c757d",
              color: "#fff",
              padding: "8px 12px",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
          <button
            type="submit"
            style={{
              background: "#007bff",
              color: "#fff",
              padding: "8px 12px",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Guardar
          </button>
        </div>
      </form>
    </Modal>
  );
}
